import React from 'react';

const HeaderSection = () => {
  return (
    <div className="flex flex-col items-center w-full max-w-[1198px] mx-auto p-4">
      <div className="text-[#ef8702] text-center font-black text-lg tracking-[0.8px] mb-4" style={{ fontFamily: 'Axiforma' }}>
        LANGUAGES WE SUPPORT
      </div>
      
      <div className="flex flex-col items-center gap-4">
        <h1 className="text-black text-3xl font-black text-center leading-tight" style={{ fontFamily: 'Axiforma' }}>
          Boosting Your Platforms Through These Languages
        </h1>
        
        <p className="text-black text-base font-normal text-center">
          Our platform offers AI-powered translation and speech tools for the following languages, with more coming soon.
        </p>
      </div>
    </div>
  );
};

export default HeaderSection;

